import {
  CONSOLE_ROUTES,
  ConsoleInviteAcceptedSchema,
  ConsoleMeSchema,
  ConsoleSignInOptionsSchema,
} from '@plato/shared';
import type { ConsoleAuth } from './console-auth.ts';
import { ConsoleApiError, callConsoleApi, sendToConsoleApi } from './http-client.ts';

export const httpConsoleAuth: ConsoleAuth = {
  async getMe() {
    try {
      return await callConsoleApi(CONSOLE_ROUTES.me, ConsoleMeSchema);
    } catch (error) {
      if (error instanceof ConsoleApiError && error.status === 401) return null;
      throw error;
    }
  },

  listSignInProviders: async () =>
    (await callConsoleApi(CONSOLE_ROUTES.signInProviders, ConsoleSignInOptionsSchema)).providers,

  signInUrl: (provider) => CONSOLE_ROUTES.signIn(provider),

  devSignIn: (email, platoStaff) =>
    sendToConsoleApi(CONSOLE_ROUTES.devSignIn, {
      method: 'POST',
      body: { email, plato_staff: platoStaff },
    }),

  signOut: () => sendToConsoleApi(CONSOLE_ROUTES.signOut, { method: 'POST' }),

  acceptInvite: async (token) =>
    (
      await callConsoleApi(CONSOLE_ROUTES.inviteAccept, ConsoleInviteAcceptedSchema, {
        method: 'POST',
        body: { token },
      })
    ).tenant,
};
